import React from "react";
import { noop } from "lodash";

import Checkbox from "../../_molecule/Checkbox";
import {
  Container,
  Wrapper,
  TextContainer,
  Title,
  Description,
  Button,
  CheckBoxContainer
} from "./styled-components";

const SelectableBox = ({
  title,
  description,
  buttonText,
  id,
  name,
  isChecked,
  setChecked,
  qaLabel,
  radioName,
  onClick,
  buttonTextOnClick
}) => {
  return (
    <Container isChecked={isChecked}>
      <Wrapper isChecked={isChecked}>
        <TextContainer>
          <Title data-qa-label="promo-code-title">{title}</Title>
          {!!description && (
            <Description data-qa-label="promo-code-description">
              {description}
            </Description>
          )}
          {!!buttonText && (
            <Button onClick={buttonTextOnClick}>{buttonText}</Button>
          )}
        </TextContainer>
        <CheckBoxContainer>
          <Checkbox
            id={id}
            setChecked={setChecked}
            name={name}
            value={id}
            qaLabel={qaLabel + isChecked.toString()}
            radioName={radioName}
            isRadioChecked={isChecked}
            hasMarginBottom={false}
            isRadio
            onClick={onClick || noop}
          />
        </CheckBoxContainer>
      </Wrapper>
    </Container>
  );
};

SelectableBox.defaultProps = {
  title: "title",
  qaLabel: "promo-code-check-box",
  radioName: "promo-code-radio"
};

export default SelectableBox;
